import { MediaFormatEnum } from '../../../../general-settings/enums/mediaFormat.enum';

const ASPECT_RATIO_BY_MEDIA_FORMAT: Record<MediaFormatEnum, number> = {
  [MediaFormatEnum.SQUARE]: 1,
  [MediaFormatEnum.RECTANGULAR]: 10 / 16,
};

export const getMediaAspectRatio = (mediaFormat: MediaFormatEnum) =>
  ASPECT_RATIO_BY_MEDIA_FORMAT[mediaFormat];
